module.exports = __webpack_public_path__ + "static/media/audit_log.1fe8df89.svg";